import Ungroup from "./Ungroup";

export * from "./Archive";
export * from "./ArchiveRestore";
export * from "./ArchiveX";
export * from "./BookImage";
export * from "./CalenderFold";
export * from "./File";
export * from "./FileArchive";
export * from "./FileAudio";
export * from "./FileAudio2";
export * from "./FileAxis3D";
export * from "./FileBadge";
export * from "./FileBox";
export * from "./FileChartColumn";
export * from "./FileChartColumnIncreasing";
export * from "./FileChartLine";
export * from "./FileChartPie";
export * from "./FileCheck";
export * from "./FileCheck2";
export * from "./FileClock";
export * from "./FileCog";
export * from "./FileHeart";
export * from "./FileImage";
export * from "./FileJson2";
export * from "./FileKey";
export * from "./FileKey2";
export * from "./FileLock";
export * from "./FileLock2";
export * from "./FileMinus";
export * from "./FIleMinus2";
export * from "./FileMusic";
export * from "./FilePen";
export * from "./FilePenLine";
export * from "./FilePlus";
export * from "./FilePlus2";
export * from "./Files";
export * from "./FileScan";
export * from "./FileSearch";
export * from "./FileSearch2";
export * from "./FileSlider";
export * from "./FileSpreadsheet";
export * from "./FileText";
export * from "./FileType";
export * from "./FileType2";
export * from "./FileVideo";
export * from "./FileVideo2";
export * from "./FileVolume";
export * from "./FileVolume2";
export * from "./FileX";
export * from "./FileX2";
export * from "./Folder";
export * from "./FolderArchive";
export * from "./FolderCheck";
export * from "./FolderClock";
export * from "./FolderClosed";
export * from "./FolderCog";
export * from "./FolderGit";
export * from "./FolderGit2";
export * from "./FolderHeart";
export * from "./FolderKey";
export * from "./FolderLock";
export * from "./FolderMinus";
export * from "./FolderOpen";
export * from "./FolderOpenDot";
export * from "./FolderPen";
export * from "./FolderPlus";
export * from "./Folders";
export * from "./FolderSearch";
export * from "./FolderSearch2";
export * from "./FileSymilink";
export * from "./FolderTree";
export * from "./FolderX";
export * from "./Group";
export * from "./Image";
export * from "./ImageDown";
export * from "./ImageMinus";
export * from "./ImageOff";
export * from "./ImagePlay";
export * from "./ImagePlus";
export * from "./Images";
export * from "./ListTree";
export * from "./Music";
export * from "./Music2";
export * from "./Music3";
export * from "./Music4";
export * from "./PaperClip";
export * from "./Save";
export * from "./SaveAll";
export * from "./SaveOff";
export * from "./Sheet";
export * from "./TableCellsSplit";
export * from "./TableColumnsSplit";
export * from "./TableProperties";
export * from "./TableRowsSplit";
export * from "./Trash";
export * from "./Trash2";
export * from "./Ungroup";

export const Folderss = {
  Ungroup,
};
